import React, { useEffect, useState } from 'react'

import {product} from '../data';
import { Link, useParams } from 'react-router-dom';

import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import { Carousel } from 'react-responsive-carousel';

function ProductId() {
  const [spek, setSpek] = useState(0);
  const { id } = useParams();
  const data = product.find((item) => item.id === id);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div>
      <div className='py-3 mb-10 bg-gold px-5 lg:px-10'>
        <Link to={`/product/${data['slug']}`} className="flex space-x-2 items-center hover:underline">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>
          </div>
          <div>
            Back to Product
          </div>
        </Link>
      </div>
      <div className="block lg:flex">
        <div className="w-full lg:w-7/12">
          <div className='flex justify-center'>
            <Carousel dynamicHeight={true} emulateTouch={true} infiniteLoop={true} centerMode={true} autoPlay={true} className="w-full lg:w-11/12">
              {
                data['gambar'].map((item, index) => (
                      <img src={item} key={index} className="" alt="" />
                ))
              }
            </Carousel>
          </div>
        </div>
        {
          data['slug'] === 'wood-furniture' && (
            <div className="w-full lg:w-5/12 px-10 space-y-3">
              <div className='text-2xl font-medium'>{data['nama']}</div>
              <div className='text-xl'>{data['tipe']}</div>
              <div className='font-bold text-3xl'>${data['harga'][spek]}</div>
              <div className="w-full grid grid-cols-2 gap-4" onChange={(e) => console.log(e.target.value)}>
                {
                  data['spek'].map((item, index) => (
                    <div key={index} className='w-full flex' onClick={() => setSpek(index)}>
                      <button className={`w-full border border-black text-black px-5 py-2 rounded-md ${spek === index ? 'bg-gold' : ''}`}>{item}</button>
                    </div>
                  ))
                }
              </div>

              <div className="flex">
                <a href={`https://api.whatsapp.com/send/?phone=6281297108565&text=Hello, im interest with ${data['nama']}, can you show detail?`} target="_blank"  rel="noreferrer" className='bg-gold py-2 px-5 text-center w-full rounded-full hover:bg-yellow-400 font-bold '>Contact Us</a>
              </div>

              <div className='space-y-4'>
                <div className='font-bold text-xl'>Description</div>
                <div className='whitespace-pre-wrap'>
                  Our nature has it’s own art
                  This star teak stump table is combination of wood working and natural art, no two star table are alike, making this truly one-of-a-kind art. Look carefully at the picture, you will know where the human touch and the touch of nature are. Please be aware that most of the items are vintage/antique and may have small defects or signs of age.

                  This star table is made of teak stumps, that are dug up, cleaned, sanded and finished with a lacquer. It’s brings a unique look and feel to your home.

                  This teak stump table is made by a professional craftsman or artisans in Indonesia. Each stump table is specially handpicked and is totally unique with its own characteristics and individuality. Therefore, each root table is a little bit different, but all will look stunning for you.

                  CUSTOMIZATION available, please message your desired size and shape.
                  You can ask any information before add to cart, I'm ready to assist.
                </div>
                <div className='space-y-4'>
                  <div>
                    <span className='font-bold'>SHIPPING PROCESS:</span>
                    <br/>
                    <ul className='list-decimal'>
                      <li>
                        Free shipping (port to port)
                      </li>
                      <li>
                        LCL Cargo service. So you must pick it up directly from you nearest port/shipping agent warehouse.
                      </li>
                      <li>
                        All items are packed in secure wooden crates.
                      </li>
                      <li>
                        All items are shipped directly from Indonesia. Import duties, taxes and charges are not included in the item price.
                      These charges are the buyer's responsibility and to be paid by the customer separately. We are not responsible for any of those charges. Please check with your local customs office to determine what these additional charges will be prior to buying. These charges are normally collected by the delivering freight (shipping) company or when you pick up the item. Please do not confuse them for additional shipping charges.
                      </li>
                      <li>
                        Shipping time to USA is 30 - 90 days.
                      </li>
                    </ul> 
                    If you're living in the USA, be prepared to filling ISF form. As it's required by the US Government.
                    <br/>
                  </div>
                  <div>
                    <div className='font-bold'>RETURNS & EXCHANGE:</div>
                    I gladly accept cancellations, Request a cancellation within 24 hours of purchase
                    <br/>
                    I don't accept returns or exchanges, but please contact me if you have any problems with your order.
                    <br/>
                  </div>

                  CUSTOMS & IMPORT TAXES:
                  <br/>
                  Buyers are responsible for any customs and import taxes that may apply. I'm not responsible for delays due to customs.
                  <br/>
                </div>
              </div>
            </div>
          )
        }

        {
          data['slug'] !== "wood-furniture" && (
            <div className="w-full lg:w-5/12 px-10 space-y-3">
              <div className='text-2xl font-medium'>
                {data['nama']}
              </div>
              <div>
                {data['deskripsi']}
              </div>
              <div className='flex'>
                <a href={`https://api.whatsapp.com/send/?phone=6281297108565&text=Hello, im interest with ${data['nama']}, can you show detail?`} target="_blank"  rel="noreferrer" className='bg-gold py-2 px-5 text-center w-full rounded-full hover:bg-yellow-400 font-bold '>Contact Us</a>
              </div>
            </div>
          )
        }
      </div>
    </div>
  )
}

export default ProductId